import { render, staticRenderFns } from "./contactSendsPattern.vue?vue&type=template&id=d96bf6e0"
import script from "./contactSendsPattern.vue?vue&type=script&lang=js"
export * from "./contactSendsPattern.vue?vue&type=script&lang=js"
import style0 from "./contactSendsPattern.vue?vue&type=style&index=0&id=d96bf6e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports